/* global App */
import { React } from 'vendor-react';
import Label from '../Label/index';

const isNotEmpty = App.Utils.Object.isNotEmpty;
const isString = App.Utils.Object.isString;

class InputWrapper extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openHelpText: false,
        };
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.clear = this.clear.bind(this);
    }

    getValidationStateClass() {
        const { validation } = this.props;

        if (isString(validation)) {
            return 'invalid';
        } else if (validation === true) {
            return 'valid';
        }
        return null;
    }

    getClasses() {
        const { dirty, focus } = this.props;
        const cls = ['input-wrapper'];
        const validationStatus = this.getValidationStateClass();
        validationStatus && cls.push(validationStatus);
        cls.push(dirty ? 'dirty' : 'pristine');
        focus && cls.push('focus');
        return cls.join(' ');
    }

    renderValidationMessage() {
        const { validation } = this.props;

        if (isString(validation)) {
            return <div className="input-wrapper__error-message">{validation}</div>;
        }
        return null;
    }

    clear() {
        const { onChange, onBlur, onClear } = this.props;

        if (onClear) {
            onClear();
        } else if (onChange) {
            onChange('');
        } else if (onBlur) {
            onBlur('');
        }
    }

    renderClearIcon() {
        const { value, clearOption } = this.props;
        if (clearOption && isNotEmpty(value)) {
            return (
                <div onClick={this.clear} className="input-group-text input-wrapper__clear-icon" />
            );
        }
        return null;
    }

    toggleTooltip() {
        this.setState(prevState => ({
            openHelpText: !prevState.openHelpText,
        }));
    }

    render() {
        const { label, children, required, additionalWrapperGroupClass, helpText, emailLabel } = this.props;
        const { openHelpText } = this.state;

        return (
            <div className={this.getClasses()}>
                {label && (
                    <Label
                        className="input-wrapper__label"
                        label={label}
                        required={required}
                        onTooltipClick={helpText ? this.toggleTooltip : null}
                        emailLabel={emailLabel}
                    />
                )}
                {helpText &&
                    openHelpText && (
                        <div
                            className="input-wrapper__help-text"
                            dangerouslySetInnerHTML={{ __html: helpText }}
                        />
                    )}
                <div className={`input-group ${additionalWrapperGroupClass || ''}`}>
                    {children}
                    {this.renderClearIcon()}
                </div>
                {this.renderValidationMessage()}
            </div>
        );
    }
}

export default InputWrapper;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/modules/react-forms/scripts/Components/InputWrapper/index.js